import React, { lazy } from "react";
import { CslDetailsSections } from "../../../@types/enums/csl-details-sections/CslDetailsSections";
import { Loader } from "../../root/loader";
const CslCreatePage = lazy(() => import("./"));

export const cslcreate = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/csl/:workspaceId/create/${CslDetailsSections.Registry}`,
            element: (
                <Loader>
                    <CslCreatePage section={CslDetailsSections.Registry} />
                </Loader>
            )
        }
    }
];
